import React from 'react';
import Icon from '@material-ui/icons/Visibility';

const Visibility = (props) => <Icon {...props} />;

export default Visibility;
